import React, { Component } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  SetItemsSelected,
  NotificatioErrController,
  NotificatioSucController,
  getCurrentDate,
  getCurrentTime,
  generateStockSku,
} from "../../../helpers/Utils";
import createSocket from "../../../helpers/createSocket";
import {
  PageHeading,
  ContentFormCountUpdate,
  ListItemLeftForm,
  ContentDisplay,
  ListItemFormMobile,
  StockApplicationMenu,
} from "../../../containers/pages/stock";
import { Pagination } from "../../../containers/pages/general";
import LogsHelper from "../../../helpers/Logs";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import { isC, isR, isU, isD } from "../../../helpers/Roles";
import { NavLink } from "react-router-dom";
import { Separator } from "../../../components/common/CustomBootstrap";
import TemplateWarningCard from "../../../components/common/TemplateWarningCard";
import FooterPage from "../../../containers/pages/FooterPage";
import FooterStock from "../../../containers/pages/stock/FooterStock";
import AddStock from "../../../containers/pages/stock/AddStock";
import AddMoreStock from "../../../containers/pages/stock/AddMoreStock";
import UpdateStock from "../../../containers/pages/stock/UpdateStock";
import ModalAddStocks from "../../../containers/pages/stock/ModalAddStocks";
import ContentMultiForm from "../../../containers/pages/stock/ContentMultiForm";
import StockDashboardLayout from "../../../containers/pages/stock/StockDashboardLayout";
import StockImportHistoryModal from "../../../containers/pages/stock/StockImportHistoryModal";
import { connect } from "react-redux";
import { setSearchContext } from "../../../redux/actions";
import { exportStockToExcel } from "../../../helpers/stockExport";

const DEFAULT_FORM = {
  id: "",
  name: "",
  sku: "",
  barcode: "",
  unit: "",
  unit_price: 0,
  new_count: 0,
  count: 0,
  avarage_price: "",
  total: 0,
  category_name: "",
  warehouse_name: "Kho chính",
  brand_name: "",
  packing_specification: "",
  min_stock_threshold: 0,
  max_stock_threshold: 0,
  is_active: true,
  batch_code: "",
  storage_location: "",
  stock_note: "",
  price_outcome: 0, // Đã trả cho nhà cung cấp
  items_selected: null,
  dynamic_form: [],
  expiry_date: "", // Hạn sử dụng của lô hàng
  isTemplate: false,
};

const ROLE_ALIAS = "stock";

class ContentComponent extends Component {
  constructor(props) {
    super(props);
    this.replenishmentRequestId = null;
    this.replenishmentSubmitting = false;

    this.state = {
      page: {
        pageSizes: [12, 24],
        selectedPageSize: 12,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      selectedItems: [],
      data: [],
      data_all: [],
      license: {},
      data_length: 0,
      hide_button_add: false,
      stockLimit: Infinity,
      totalStock: 0,

      data_stock: null,
      dataMakeProduct: [],
      filter: null,
      data_providers: [],

      successfulImports: [],
      failedImports: [],

      data_dynamic_form: [],
      is_loading_data: true,
      show: {
        add: false,
        update: false,
        view: false,
        updateCount: false,
      },
      accordion: [],
      activeTab: "1",
      displayMode: "thumblist",
      uiMode: localStorage.getItem("stock_ui_mode") || "new",
      dashboardFilters: {
        search: "",
        category_name: "",
        warehouse_name: "",
        status: "",
      },
      dashboardData: {
        summary: {
          total_items: 0,
          total_stock: 0,
          total_stock_value: 0,
          low_stock_count: 0,
          out_of_stock_count: 0,
        },
        breakdown: {
          total: 0,
          in_stock: { count: 0, percent: 0 },
          low_stock: { count: 0, percent: 0 },
          out_of_stock: { count: 0, percent: 0 },
          no_cost: { count: 0, percent: 0 },
        },
        alerts: {
          counts: { out_of_stock: 0, low_stock: 0, no_cost: 0 },
          items: { out_of_stock: [], low_stock: [], no_cost: [] },
        },
        recent_imports: [],
        filter_options: { category_names: [], warehouse_names: [] },
      },
      warehouseOptions: [{ label: "Kho chính", value: "Kho chính" }],
      is_loading_dashboard: false,
      isOpenStockImportModal: false,
      isOpenStockImportHistoryModal: false,
      stockImportHistoryItem: null,
      stockImportRows: [],
      stockImportReport: null,
      isImportingStockExcel: false,
      showTemplate: false,
      form: DEFAULT_FORM,
      // sku: '',
    };

    this.socket = createSocket();
  }

  fetchUserTemplateVisibility = () => {
    let tokenStr = localStorage.getItem("access_token");
    if (!tokenStr) return;
    axios
      .get(`${END_POINT}/user`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        if (data && data.data) {
          this.setState({
            showTemplate: Boolean(
              data.data.showTemplate ?? data.data.show_template,
            ),
          });
        }
      })
      .catch(() => {});
  };

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    // Set search context cho Navbar
    this.props.setSearchContext("stock");

    this.socket.on("refresh-template-data", (data) => {
      if (data && typeof data.show_template !== "undefined") {
        this.setState({
          showTemplate: Boolean(data.show_template),
        });
      } else {
        this.fetchUserTemplateVisibility();
      }
    });
    this.socket.on("refresh-stock", this.handleRefreshEvent);

    this.dataListRender();
    this.dataAllRender();
    this.dataRenderProviders();
    this.dataWarehouseOptions();
    this.getLicense();
    this.dataListAllMakeProduct();
    this.fetchDashboardSummary();
    this.fetchUserTemplateVisibility();

    window.addEventListener("refresh-stock-list", this.handleRefreshEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("refresh-stock-list", this.handleRefreshEvent);
    if (this.socket) {
      this.socket.off("refresh-template-data");
      this.socket.off("refresh-stock", this.handleRefreshEvent);
      this.socket.close();
    }
  }

  handleRefreshEvent = () => {
    this.dataListRender();
    this.dataAllRender();
    this.dataRenderProviders();
    this.dataWarehouseOptions();
    this.getLicense();
    this.dataListAllMakeProduct();
    this.fetchDashboardSummary();
    this.fetchUserTemplateVisibility();
  };

  componentDidUpdate(prevProps) {
    // Listen thay đổi searchKeyword từ Redux (Navbar search)
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      // Trigger search với keyword từ Redux
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: this.props.searchKeyword,
          },
          dashboardFilters: {
            ...prev.dashboardFilters,
            search: this.props.searchKeyword,
          },
        }),
        () => this.dataListRender(),
      );
    }

    // Detect khi location.search thay đổi (click thông báo stock khác khi đang ở trang stock)
    if (
      this.props.location &&
      prevProps.location &&
      this.props.location.search !== prevProps.location.search
    ) {
      this.dataListRender();
    }
  }

  getLicense = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/user-license"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      })
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        let user_license = data.data;

        let currentDate = getCurrentDate();
        let currentTime = getCurrentTime();

        if (user_license.expired_date < currentDate && !user_license.upgraded) {
          this.setState((prev) => ({
            license: {
              using: false,
            },
          }));
        }
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
      });
  };

  hideButtonAdd = () => {
    let { stockLimit, totalStock } = this.state;
    // Fix: infinity converts to null in JSON, so we check using Number.isFinite
    if (Number.isFinite(stockLimit) && totalStock >= stockLimit) {
      this.setState({
        hide_button_add: true,
      });
    } else {
      this.setState({
        hide_button_add: false,
      });
    }
  };

  toggleStockImportModal = () => {
    this.setState((prev) => ({
      isOpenStockImportModal: !prev.isOpenStockImportModal,
      stockImportRows: prev.isOpenStockImportModal ? [] : prev.stockImportRows,
      successfulImports: prev.isOpenStockImportModal
        ? []
        : prev.successfulImports,
      failedImports: prev.isOpenStockImportModal ? [] : prev.failedImports,
      stockImportReport: prev.isOpenStockImportModal
        ? null
        : prev.stockImportReport,
    }));
  };

  normalizeExcelHeader = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/[_-]/g, " ");

  normalizeExcelNumber = (value) => {
    if (value === null || value === undefined || value === "") return "";
    if (typeof value === "number") return Number.isFinite(value) ? value : "";

    const raw = String(value).trim();
    if (!raw) return "";

    const cleaned = raw.replace(/\s/g, "");
    const hasComma = cleaned.includes(",");
    const hasDot = cleaned.includes(".");

    if (hasComma && hasDot) {
      const lastComma = cleaned.lastIndexOf(",");
      const lastDot = cleaned.lastIndexOf(".");
      const decimalSeparator = lastComma > lastDot ? "," : ".";
      const thousandSeparator = decimalSeparator === "," ? "." : ",";
      const normalized = cleaned
        .replace(new RegExp(`\\${thousandSeparator}`, "g"), "")
        .replace(decimalSeparator, ".");
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : "";
    }

    if (hasComma) {
      const normalized = cleaned.replace(/\./g, "").replace(",", ".");
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : "";
    }

    const normalized = cleaned.replace(/,/g, "");
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : "";
  };

  handleDownloadStockImportTemplate = () => {
    const sampleRows = [
      {
        "Tên nguyên liệu": "Bột mì",
        Barcode: "893000000001",
        "Đơn vị": "kg",
        "Danh mục": "Nguyên liệu khô",
        Kho: "Kho chính",
        "Tồn tối thiểu": 10,
        "Mã lô": "LOT-2026-001",
        "Vị trí lưu kho": "Kệ A1",
        "Ghi chú": "Hàng nhập mẫu",
        "Nhà cung cấp": "Nhà cung cấp A",
        "Giá mua": 25000,
        "Số lượng": 20,
        "Đã trả": 500000,
        "Hạn sử dụng": "2026-12-31",
      },
    ];
    const ws = XLSX.utils.json_to_sheet(sampleRows);
    ws["!cols"] = [
      { wch: 24 },
      { wch: 16 },
      { wch: 10 },
      { wch: 18 },
      { wch: 14 },
      { wch: 14 },
      { wch: 16 },
      { wch: 18 },
      { wch: 24 },
      { wch: 20 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 14 },
    ];
    const wb = { Sheets: { "Nhap kho": ws }, SheetNames: ["Nhap kho"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(blob, "mau-nhap-kho-ton-kho.xlsx");
  };

  handleStockExcelFileUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        const pick = (item, keys) => {
          const headerMap = Object.keys(item).reduce((acc, key) => {
            acc[this.normalizeExcelHeader(key)] = key;
            return acc;
          }, {});

          const key = keys
            .map((name) => headerMap[this.normalizeExcelHeader(name)])
            .find(
              (matchedKey) =>
                matchedKey &&
                item[matchedKey] !== undefined &&
                item[matchedKey] !== null &&
                String(item[matchedKey]).trim() !== "",
            );
          return key ? item[key] : "";
        };

        const mappedData = jsonData.map((item) => ({
          name: pick(item, ["name", "Tên nguyên liệu", "Tên sản phẩm"]),
          sku: pick(item, ["sku", "SKU", "Mã SKU"]),
          barcode: pick(item, ["barcode", "Barcode", "Mã Barcode"]),
          unit: pick(item, ["unit", "Đơn vị", "ĐVT"]),
          supplier: pick(item, ["supplier", "Nhà cung cấp"]),
          quantity: this.normalizeExcelNumber(
            pick(item, ["quantity", "Số lượng", "count", "Tồn kho"]),
          ),
          price: this.normalizeExcelNumber(
            pick(item, ["price", "Đơn giá", "price_new", "Giá mua"]),
          ),
          paid: this.normalizeExcelNumber(pick(item, ["paid", "Đã trả"])),
          expiry_date: pick(item, ["expiry_date", "Hạn sử dụng"]),
          category_name: pick(item, ["category_name", "Danh mục", "category"]),
          warehouse_name: pick(item, ["warehouse_name", "Kho", "warehouse"]),
          min_stock_threshold: pick(item, [
            "min_stock_threshold",
            "Tồn tối thiểu",
            "minimum_stock",
          ])
            ? this.normalizeExcelNumber(
                pick(item, [
                  "min_stock_threshold",
                  "Tồn tối thiểu",
                  "minimum_stock",
                ]),
              )
            : "",
          batch_code: pick(item, ["batch_code", "Mã lô", "lot_code"]),
          storage_location: pick(item, [
            "storage_location",
            "Vị trí lưu kho",
            "storage_bin",
          ]),
          stock_note: pick(item, ["stock_note", "Ghi chú nhập kho", "Ghi chú"]),
        }));

        this.setState({
          stockImportRows: mappedData,
          stockImportReport: null,
          successfulImports: [],
          failedImports: [],
        });
      } catch (error) {
        NotificatioErrController("Không thể đọc file Excel đã chọn.");
      }
    };
    reader.readAsArrayBuffer(file);
    event.target.value = "";
  };

  onHandlerImport = (dataImport) => {
    if (!isC(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    this.setState({ isImportingStockExcel: true, stockImportReport: null });

    axios
      .post(
        `${END_POINT + "/stock/import-stock"}`,
        { data: dataImport },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        if (data.success === false) {
          // Service check
          NotificatioErrController(data.message || "Có lỗi xảy ra");
        } else {
          const successful = data?.data?.successful || [];
          const failed = data?.data?.failed || [];
          const successfulImports = successful.map((item) => ({
            ...item.data,
            responseText: item.responseText,
          }));
          const failedImports = failed.map((item) => ({
            ...item.data,
            responseText: item.responseText,
          }));
          const report = {
            message: data.message,
            successful,
            failed,
          };

          if (failed.length > 0) {
            NotificatioErrController(
              data.message ||
                `Hoàn tất nhập kho. Thành công: ${successful.length}, Thất bại: ${failed.length}.`,
            );
          } else {
            NotificatioSucController(
              data.message || "Nhập kho hàng loạt thành công!",
            );
          }

          /* LEGACY_STOCK_IMPORT_GENERIC_SUCCESS_START
          // ImportStock service returns array of results? Or generic success?
          // Based on code, it returns array of results or errors per batch?
          // Actually currently it seems to return object with status?
          // Let's assume generic success for now or handle list.
          // Looking at service: returns `allResults`? No, it collects allResults.
          // Wait, service returns what?
          // I should double check service return.
          // But usually:
          NotificatioSucController("Nhập liệu thành công!");
          LEGACY_STOCK_IMPORT_GENERIC_SUCCESS_END */
          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: "Đã nhập danh sách nguyên liệu",
          });
          this.socket.emit("refresh-stock", {
            user_id: localStorage.getItem("user_id"),
          });
          this.dataListRender();
          this.dataAllRender();
          this.fetchDashboardSummary();
          /* LEGACY_STOCK_IMPORT_CLOSE_MODAL_ON_SUCCESS_START
          this.setState({
            isOpenStockImportModal: false,
            stockImportRows: [],
            successfulImports: [],
            failedImports: [],
          });
          LEGACY_STOCK_IMPORT_CLOSE_MODAL_ON_SUCCESS_END */
          this.setState({
            stockImportReport: report,
            successfulImports,
            failedImports,
          });
        }
        /* LEGACY_STOCK_IMPORT_PAGE_LOADING_START
        this.setState({ is_loading_data: false });
        LEGACY_STOCK_IMPORT_PAGE_LOADING_END */
        // Close modal if needed? props toggleUnifiedModal?
        // This is inside ContentComponent. PageHeading handles modal state.
        // We might need a way to close modal.
        // But PageHeading controls modal state.
        // We can callback?
        // onHandlerImport is passed to PageHeading -> ModalAddStocks.
        // When successful, we should probably close the modal.
        // But PageHeading state isOpenUnifiedModal is in PageHeading.
        // We can't close it from here easily unless we pass a callback.
        // Or PageHeading listens to props? No.
        // Maybe just alert success is enough for now.
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText ||
            err.response?.data?.message ||
            "Có lỗi xảy ra khi nhập kho.",
        );
      })
      .finally(() => {
        this.setState({ isImportingStockExcel: false });
      });
  };

  /** Axios func helper */
  dataListRender = (required = true) => {
    const { selectedPageSize, currentPage, search } = this.state.page;
    const { category_name, warehouse_name, status } =
      this.state.dashboardFilters;

    const query = [
      `pageSize=${selectedPageSize}`,
      `currentPage=${currentPage}`,
      `search=${encodeURIComponent(search || "")}`,
      `category_name=${encodeURIComponent(category_name || "")}`,
      `warehouse_name=${encodeURIComponent(warehouse_name || "")}`,
      `status=${encodeURIComponent(status || "")}`,
    ].join("&");

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/stock/json"}?${query}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        // console.log(data);
        // Use React Router's location.search instead of window.location.search
        // to correctly handle query params with HashRouter (Electron/desktop)
        let search = this.props.location
          ? this.props.location.search
          : window.location.search;
        let params = new URLSearchParams(search);
        let item_id = null;
        let item_vs_percent = params.get("item_id");
        if (item_vs_percent) {
          const split_item_vs_percent = item_vs_percent.split(".");

          if (split_item_vs_percent.length) {
            item_id = split_item_vs_percent[0];

            const find_item = data.data.find((_item) => _item.id == item_id);
            if (find_item !== undefined) {
              this.onClickedUpdate(find_item);
              this.onClickedUpdateCount(find_item);
            }
          }
        }

        let anyAccordion = [];
        let numeroPerguntas = data.data.length;
        for (var i = 0; i < numeroPerguntas; i++) {
          // if (!i) {
          //     anyAccordion.push(true);
          // }
          anyAccordion.push(false);
        }

        this.setState(
          (prev) => ({
            ...prev,
            data: data.data,
            data_dynamic_form: data.dataDynamicForm,
            is_loading_data: false,
            page: {
              ...prev.page,
              totalPage: data.totalPage,
              totalItem: data.totalItem,
            },
            accordion: anyAccordion,
            stockLimit: data.stockLimit,
            totalStock: data.totalStock,
          }),
          () => {
            if (required) {
              if (this.state.form.id) {
                const {
                  id,
                  name,
                  barcode,
                  sku,
                  unit,
                  price_new,
                  total_value,
                  avarage_price,
                  count,
                  income,
                  total,
                  category_name,
                  warehouse_name,
                  min_stock_threshold,
                  batch_code,
                  storage_location,
                  stock_note,
                  dynamic_form,
                  isTemplate,
                } = this.state.form;
                this.setState((prev) => ({
                  ...prev,
                  form: {
                    ...prev.form,
                    id,
                    name,
                    barcode,
                    sku,
                    unit,
                    price_new,
                    total_value,
                    avarage_price,
                    count,
                    income,
                    total,
                    category_name,
                    warehouse_name,
                    min_stock_threshold,
                    batch_code,
                    storage_location,
                    stock_note,
                    dynamic_form,
                  },
                }));
              } else {
                this.setState((prev) => ({
                  ...prev,
                  selectedItems: [],
                  show: {
                    ...prev.show,
                    update: false,
                  },
                  form: DEFAULT_FORM,
                }));
              }
            }
          },
        );
        this.hideButtonAdd();
        this.fetchDashboardSummary();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataAllRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/stock/all-unit"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_all: data.data,
          data_length: data.data.length,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataWarehouseOptions = () => {
    let tokenStr = localStorage.getItem("access_token");

    axios
      .get(`${END_POINT + "/companies/child"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((res) => {
        const linkedWarehouses = (res.data || [])
          .map((item) => item?.label || item?.name)
          .filter(Boolean)
          .map((name) => String(name).trim())
          .filter(Boolean);

        const warehouseNames = Array.from(
          new Set(["Kho chính"].concat(linkedWarehouses)),
        );

        this.setState((prev) => ({
          ...prev,
          warehouseOptions: warehouseNames.map((name) => ({
            label: name,
            value: name,
          })),
        }));
      })
      .catch(() => {
        this.setState((prev) => ({
          ...prev,
          warehouseOptions: [{ label: "Kho chính", value: "Kho chính" }],
        }));
      });
  };

  // dataAllRenderSoftDel = () => {
  //     let tokenStr = localStorage.getItem('access_token');
  //     axios
  //         .get(`${END_POINT + '/stock/all-soft-del'}`, {
  //             headers: { Authorization: `Bearer ${tokenStr}` },
  //         })
  //         .then((res) => res.data)
  //         .then((data) => {
  //             // console.log('dataStockSoftDel: ', data.data);
  //             // const getSKU = data.data.length + 1;
  //             // this.setState((prev) => ({
  //             //     ...prev,
  //             //     sku: `NVL${getSKU}`,
  //             // }));
  //         })
  //         .catch((err) => {
  //             NotificatioErrController(err.response.data.responseText);
  //             return false;
  //         });
  // };

  dataListAllMakeProduct() {
    let tokenStr = localStorage.getItem("access_token");

    return axios
      .get(`${END_POINT + "/make-product/all"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        this.setState((prev) => ({
          ...prev,
          dataMakeProduct: res.data.data,
        }));
        // return res.data.data;
      })
      .catch((err) => []);
  }

  dataRenderProviders = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/company-provider"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        this.setState((prev) => ({
          ...prev,
          data_providers: data.data,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  fetchDashboardSummary = () => {
    const tokenStr = localStorage.getItem("access_token");
    const { search, category_name, warehouse_name, status } =
      this.state.dashboardFilters;
    const query = [
      `search=${encodeURIComponent(search || "")}`,
      `category_name=${encodeURIComponent(category_name || "")}`,
      `warehouse_name=${encodeURIComponent(warehouse_name || "")}`,
      `status=${encodeURIComponent(status || "")}`,
    ].join("&");

    this.setState({ is_loading_dashboard: true });
    axios
      .get(`${END_POINT + "/stock/dashboard-summary"}?${query}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((result) => {
        this.setState((prev) => ({
          ...prev,
          dashboardData: result.data || prev.dashboardData,
          is_loading_dashboard: false,
        }));
      })
      .catch(() => {
        this.setState({ is_loading_dashboard: false });
      });
  };

  toggleUIMode = () => {
    this.setState(
      (prev) => {
        const nextMode = prev.uiMode === "new" ? "legacy" : "new";
        localStorage.setItem("stock_ui_mode", nextMode);
        return { ...prev, uiMode: nextMode };
      },
      () => this.fetchDashboardSummary(),
    );
  };

  onDashboardFilterChange = (key, value) => {
    this.setState(
      (prev) => ({
        ...prev,
        dashboardFilters: {
          ...prev.dashboardFilters,
          [key]: value,
        },
      }),
      () => {
        if (key !== "search") {
          this.setState(
            (prev) => ({
              ...prev,
              page: {
                ...prev.page,
                currentPage: 1,
              },
            }),
            () => this.dataListRender(),
          );
        }
      },
    );
  };

  onDashboardSearchChange = (value) => {
    this.setState((prev) => ({
      ...prev,
      dashboardFilters: {
        ...prev.dashboardFilters,
        search: value,
      },
    }));
  };

  onDashboardSearch = (value) => {
    this.setState(
      (prev) => ({
        ...prev,
        dashboardFilters: {
          ...prev.dashboardFilters,
          search: value,
        },
        page: {
          ...prev.page,
          search: value,
          currentPage: 1,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onDashboardSearchKeyDown = (event) => {
    if (event.key === "Enter") {
      this.applyDashboardFilters();
    }
  };

  applyDashboardFilters = () => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          search: prev.dashboardFilters.search || "",
          currentPage: 1,
        },
      }),
      () => this.dataListRender(),
    );
  };

  resetDashboardFilters = () => {
    this.setState(
      (prev) => ({
        ...prev,
        dashboardFilters: {
          search: "",
          category_name: "",
          warehouse_name: "",
          status: "",
        },
        page: {
          ...prev.page,
          search: "",
          currentPage: 1,
        },
      }),
      () => this.dataListRender(),
    );
  };

  handleExportStock = () => {
    exportStockToExcel({
      data: this.state.data,
    });
  };

  openStockImportHistory = (item) => {
    this.setState({
      isOpenStockImportHistoryModal: true,
      stockImportHistoryItem: item,
    });
  };

  toggleStockImportHistoryModal = () => {
    this.setState((prev) => ({
      isOpenStockImportHistoryModal: !prev.isOpenStockImportHistoryModal,
      stockImportHistoryItem: prev.isOpenStockImportHistoryModal
        ? null
        : prev.stockImportHistoryItem,
    }));
  };

  handleStockImportHistorySaved = () => {
    this.socket.emit("refresh-stock", {
      user_id: localStorage.getItem("user_id"),
    });
    this.socket.emit("refresh-alert-data", {
      user_id: localStorage.getItem("user_id"),
    });
    this.dataListRender(false);
    this.dataAllRender();
    this.fetchDashboardSummary();
  };

  handleToggleSelectAllCurrent = () => {
    this.setState((prev) => {
      const pageIds = (prev.data || []).map((item) => item.id);
      const allSelected = pageIds.every((id) =>
        prev.selectedItems.includes(id),
      );
      if (allSelected) {
        return {
          ...prev,
          selectedItems: prev.selectedItems.filter(
            (id) => !pageIds.includes(id),
          ),
        };
      }
      const merged = new Set([...prev.selectedItems, ...pageIds]);
      return {
        ...prev,
        selectedItems: Array.from(merged),
      };
    });
  };

  onHandlerDelete = () => {
    if (!isD(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT + "/stock"}`, {
        data: {
          arrayId: this.state.selectedItems,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["stock-delete"],
        });

        this.socket.emit("refresh-stock", {
          user_id: localStorage.getItem("user_id"),
        });

        this.dataListRender();
        this.dataAllRender();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerUpdate = (e) => {
    if (!isU(ROLE_ALIAS)) return false;
    e.preventDefault();

    const {
      id,
      name,
      barcode,
      unit,
      category_name,
      warehouse_name,
      brand_name,
      packing_specification,
      min_stock_threshold,
      max_stock_threshold,
      is_active,
      stock_note,
      dynamic_form,
      isTemplate,
    } = this.state.form;
    // console.log('form: ', this.state.form);

    if (!name || !id || !unit) {
      NotificatioErrController("Dữ liệu không hợp lệ");
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/stock"}`,
        {
          id,
          name,
          barcode,
          unit,
          category_name,
          warehouse_name,
          brand_name: brand_name || null,
          packing_specification: packing_specification || null,
          min_stock_threshold,
          max_stock_threshold: Number(max_stock_threshold) || 0,
          is_active: is_active !== undefined ? Boolean(is_active) : true,
          stock_note,
          dynamic_form,
          isTemplate: Boolean(isTemplate),
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController(
          isTemplate
            ? "Chuyển thành dữ liệu thật thành công!"
            : "Cập nhật nguyên liệu thành công!",
        );

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["stock-update"],
        });

        this.socket.emit("refresh-stock", {
          user_id: localStorage.getItem("user_id"),
        });

        this.dataListRender();
        this.dataAllRender();
        this.toggle("update");
      })
      .catch((err) => {
        NotificatioErrController(
          err.response?.data?.responseText || "Không thể cập nhật nguyên liệu.",
        );
        return false;
      });
  };

  onHandlerUpdateCount = (e) => {
    if (!isU(ROLE_ALIAS)) return false;
    if (e && e.preventDefault) e.preventDefault();
    if (this.replenishmentSubmitting) return false;

    const {
      id,
      name,
      new_count,
      unit_price,
      items_selected,
      price_outcome,
      expiry_date,
      batch_code,
      storage_location,
      stock_note,
    } = this.state.form;

    // Improved validation - check for actual values, not just truthy
    if (!name || !id) {
      NotificatioErrController("Vui lòng chọn nguyên liệu");
      return;
    }
    if (
      new_count === "" ||
      new_count === undefined ||
      new_count === null ||
      Number(new_count) <= 0
    ) {
      NotificatioErrController(
        "Vui lòng nhập số lượng bổ sung (phải lớn hơn 0)",
      );
      return;
    }
    if (
      unit_price === "" ||
      unit_price === undefined ||
      unit_price === null ||
      Number(String(unit_price).replace(/\./g, "")) <= 0
    ) {
      NotificatioErrController("Vui lòng nhập đơn giá (phải lớn hơn 0)");
      return;
    }

    this.replenishmentSubmitting = true;
    if (!this.replenishmentRequestId) this.replenishmentRequestId = uuidv4();
    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/stock/count"}`,
        {
          id,
          count: new_count,
          unit_price: unit_price.toString().replace(/\./g, ""),
          item_data: items_selected ? { ...items_selected } : null,
          price_outcome: price_outcome
            ? price_outcome.toString().replace(/\./g, "")
            : "0",
          expiry_date: expiry_date
            ? moment(expiry_date).isValid()
              ? moment(expiry_date).format("YYYY-MM-DD")
              : expiry_date
            : null,
          batch_code: batch_code || null,
          storage_location: storage_location || null,
          stock_note: stock_note || null,
          request_id: this.replenishmentRequestId,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        this.replenishmentRequestId = null;
        if (data.status === 202 || data.stock_in_status === "pending_approval") {
          NotificatioSucController("Phiếu nhập đã gửi duyệt. Tồn kho chưa thay đổi.");
          this.setState((prev) => ({
            ...prev,
            form: {
              ...prev.form,
              items_selected: null,
              price_outcome: 0,
              new_count: 0,
              unit_price: 0,
              expiry_date: "",
            },
          }), () => {
            if (this.state.show.update) this.toggle("update");
            if (this.state.show.updateCount) this.toggle("updateCount");
          });
          return;
        }

        NotificatioSucController("Bổ sung nguyên liệu thành công!");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["stock-add-more"],
        });

        this.socket.emit("refresh-stock", {
          user_id: localStorage.getItem("user_id"),
        });

        this.socket.emit("refresh-alert-data", {
          user_id: localStorage.getItem("user_id"),
        });

        if (data.status === 200 && data.data) {
          this.setState(
            (prev) => ({
              ...prev,
              form: {
                ...prev.form,
                count: data.data.count,
                total: data.data.total,
                // Reset các fields sau khi bổ sung thành công
                items_selected: null,
                price_outcome: 0,
                new_count: 0,
                unit_price: 0,
                expiry_date: "",
              },
            }),
            () => {
              if (this.state.show.update) {
                this.toggle("update");
              }
              if (this.state.show.updateCount) {
                this.toggle("updateCount");
              }
              this.dataListRender(false);
            },
          );
        }
      })
      .catch((err) => {
        NotificatioErrController(err.response?.data?.responseText || "Có lỗi xảy ra");
        return false;
      })
      .finally(() => {
        this.replenishmentSubmitting = false;
      });
  };

  onHandlerAdd = (e) => {
    if (!isC(ROLE_ALIAS)) return false;
    e.preventDefault();

    const {
      name,
      sku,
      barcode,
      unit,
      category_name,
      warehouse_name,
      brand_name,
      packing_specification,
      min_stock_threshold,
      max_stock_threshold,
      is_active,
      batch_code,
      storage_location,
      stock_note,
      new_count,
      unit_price,
      price_outcome,
      items_selected,
      dynamic_form,
      expiry_date,
    } = this.state.form;

    if (!name) {
      NotificatioErrController("Tên nguyên liệu cần được thêm vào");
      return;
    }
    if (!unit) {
      NotificatioErrController("Đơn vị tính cần được thêm vào");
      return;
    }
    if (!new_count) {
      NotificatioErrController("Đơn giá cần được thêm vào");
      return;
    }

    const { data_all } = this.state;
    const isDuplicateName = data_all.some(
      (item) =>
        item.name &&
        item.name.trim().toLowerCase() === name.trim().toLowerCase(),
    );

    if (isDuplicateName) {
      NotificatioErrController("Tên nguyên liệu đã tồn tại");
      return;
    }

    if (barcode && barcode.trim() !== "") {
      const isDuplicateBarcode = data_all.some(
        (item) => item.barcode && item.barcode.trim() === barcode.trim(),
      );

      if (isDuplicateBarcode) {
        NotificatioErrController("Mã barcode đã tồn tại");
        return;
      }
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/stock"}`,
        {
          name,
          sku: sku || generateStockSku(),
          barcode,
          unit,
          category_name,
          warehouse_name,
          brand_name: brand_name || null,
          packing_specification: packing_specification || null,
          min_stock_threshold,
          max_stock_threshold: Number(max_stock_threshold) || 0,
          is_active: is_active !== undefined ? Boolean(is_active) : true,
          batch_code,
          storage_location,
          stock_note,
          count: new_count,
          unit_price: unit_price.toString().replace(/\./g, ""),
          price_outcome: price_outcome
            ? price_outcome.toString().replace(/\./g, "")
            : "0",
          item_data: { ...items_selected },
          dynamic_form,
          expiry_date: expiry_date || null, // Hạn sử dụng của lô hàng
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thêm nguyên liệu thành công!");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["stock-create"],
        });

        this.socket.emit("refresh-stock", {
          user_id: localStorage.getItem("user_id"),
        });

        this.setState((prev) => ({
          ...prev,
          form: {
            ...DEFAULT_FORM,
            sku: generateStockSku(),
          },
        }));

        this.dataListRender();
        this.dataAllRender();
        // this.dataAllRenderSoftDel();
        // this.toggle('add');
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  handleImportStock = (dataArray) => {
    let tokenStr = localStorage.getItem("access_token");

    // Kiểm tra xem token có tồn tại không
    if (!tokenStr) {
      NotificatioErrController(
        "Lỗi: Chưa đăng nhập hoặc không tìm thấy token.",
      );
      return; // Dừng thực thi nếu không có token
    }

    // Kiểm tra xem END_POINT có được định nghĩa không
    if (!END_POINT) {
      NotificatioErrController("Lỗi: Cấu hình END_POINT bị thiếu.");
      return;
    }

    axios
      .post(
        `${END_POINT + "/stock/import-stock"}`,
        { data: dataArray },
        {
          headers: {
            Authorization: `Bearer ${tokenStr}`,
          },
        },
      )
      .then((res) => res.data)
      .then((responseData) => {
        console.log("Server Response:", responseData); // Log phản hồi từ server
        NotificatioSucController(responseData.message || "Import thành công!"); // Hiển thị thông báo từ server

        const { successful, failed } = responseData.data;

        // Nếu có sản phẩm import thành công, cập nhật UI
        if (successful && successful.length > 0) {
          this.socket.emit("create logs", {
            user_id: localStorage.getItem("user_id"),
            message: LogsHelper["stock-create"],
          });
          // Thay vì gọi 4 hàm, có thể chỉ cần gọi 1 hàm tổng hợp hoặc cập nhật state một cách thông minh hơn
          this.dataListRender();
          this.dataAllRender();
        }

        const successfulImports = successful.map((item) => item.data);
        const failedImports = failed.map((item) => item.data);

        // set state để hiển thị lỗi để hiển thị lên giao diện Import của người dùng
        this.setState((prev) => ({
          ...prev,
          successfulImports,
          failedImports,
        }));

        // this.dataListRender();
        // this.dataAllRender();
        // this.dataAllRenderSoftDel();
        // this.dataAllRenderStockSoftDel();
      })
      .catch((err) => {
        console.error("Lỗi khi import product:", err);
        const errorMsg =
          err.response?.data?.message ||
          "Có lỗi xảy ra, không thể gửi yêu cầu đến server.";
        NotificatioErrController(errorMsg);
      });
  };

  onHandlerReset = async () => {
    if (!isU(ROLE_ALIAS)) return false;

    let id = this.state.selectedItems[0];

    // axios submit
    let tokenStr = localStorage.getItem("access_token");
    return axios
      .put(
        `${END_POINT + "/stock/reset"}`,
        {
          id: id,
        },
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => {
        return res.data;
      })
      .then((data) => {
        NotificatioSucController("Reset nguyên liệu về 0 thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["stock-reset"],
        });

        this.socket.emit("refresh-stock", {
          user_id: localStorage.getItem("user_id"),
        });

        this.dataListRender();
        this.dataAllRender();
        this.setState((prev) => ({
          ...prev,
          form: {
            ...prev.form,
            form: DEFAULT_FORM,
          },
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
      });
  };
  /** Axios func helper */

  /** State func helper */
  toggle = (name) => {
    if (name === "add" && !isC(ROLE_ALIAS)) return false;
    if (name === "update" && !isU(ROLE_ALIAS)) return false;
    if (name === "updateCount" && !isU(ROLE_ALIAS)) return false;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: name === "add" ? false : prev.show.update,
        // update:
        //     name !== 'updateCount' ||
        //     name !== 'add' ||
        //     name !== 'update'
        //         ? false
        //         : prev.show.update,
        view: name === "add" ? false : prev.show.view,
        [name]: !prev.show[name],
      },
      selectedItems: name === "add" ? [] : prev.selectedItems,
      form:
        name === "add"
          ? !prev.show.add
            ? { ...DEFAULT_FORM, sku: generateStockSku() }
            : DEFAULT_FORM
          : prev.form,
    }));
  };

  onChangeForm = (e, _name) => {
    this.replenishmentRequestId = null;
    if (e && e.target) {
      let {
        target: { name, value },
      } = e;
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [name]: value,
        },
      }));
    } else {
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [_name]: e,
        },
      }));
    }
  };

  onChangeDynamicForm = (e, _name) => {
    if (e && e.target) {
      let {
        target: { name, value },
      } = e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [name]: value,
          },
        },
      }));
    } else {
      let value = e && e.value ? e.value : e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [_name]: value,
          },
        },
      }));
    }
  };

  onSubmitForm = (type) => {
    if (type === "update") {
      this.onHandlerUpdate();
    } else if (type === "add") {
      this.onHandlerAdd();
    }
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onSearchKey = (e) => {
    if (!e) return false;

    if (e.target) {
      let {
        target: { value },
      } = e;
      let v = value;
      if (value === undefined) {
        v = e.target.firstElementChild.value; // parent to child

        // value = v.toLowerCase();
        // this.setState(
        //     (prev) => ({
        //         ...prev,
        //         page: {
        //             ...prev.page,
        //             search: value,
        //         },
        //     }),
        //     () => this.dataListRender()
        // );
      }
      // else {
      //     value = value.toLowerCase();
      //     this.setState(
      //         (prev) => ({
      //             ...prev,
      //             page: {
      //                 ...prev.page,
      //                 search: value,
      //             },
      //         }),
      //         () => this.dataListRender()
      //     );
      // }
    }

    if (e.key === "Enter") {
      let value = e.target.value.toLowerCase();
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: value,
          },
          dashboardFilters: {
            ...prev.dashboardFilters,
            search: value,
          },
        }),
        () => this.dataListRender(),
      );
    }
  };

  onChangePageSize = (size) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          selectedPageSize: size,
          currentPage: 1,
        },
      }),
      () => this.dataListRender(),
    );
  };

  // onClickedItem = (item, callback, args) => {
  //     if (this.state.form.id !== item.id) {
  //         const { id, name, sku, unit, count, avarage_price, income, isSeen, is_alert_down_20, is_alert_down_10, price_new, total_value, total, dynamic_form } = item;
  //         this.setState(
  //             (prev) => ({
  //                 ...prev,
  //                 show: {
  //                     ...prev.show,
  //                     update: false,
  //                     view: true,
  //                     viewonly: false,
  //                 },
  //                 form: {
  //                     ...prev.form,
  //                     id,
  //                     name,
  //                     unit,
  //                     count,
  //                     avarage_price, income, isSeen, is_alert_down_20, is_alert_down_10, price_new, total_value,
  //                     total,
  //                     dynamic_form,
  //                 },
  //                 sku,
  //                 selectedItems: [item.id],
  //             }),
  //             () => {
  //                 callback(args[0], args[1], args[2]);
  //             }
  //         );
  //     }
  // };

  onClickedItem = async (item, event) => {
    // Lấy giá trị cần thiết ra khỏi event NGAY LẬP TỨC
    const isShiftKeyDown = event.shiftKey;

    // TRƯỜNG HỢP 1: Người dùng giữ phím Shift - chọn nhiều items
    if (isShiftKeyDown) {
      this.setState((prev) => {
        const { data, selectedItems, lastChecked } = prev;
        let newSelectedItems = [];

        if (lastChecked !== null) {
          const startIndex = data.findIndex((i) => i.id === lastChecked);
          const endIndex = data.findIndex((i) => i.id === item.id);

          const rangeStart = Math.min(startIndex, endIndex);
          const rangeEnd = Math.max(startIndex, endIndex);

          if (rangeStart !== -1 && rangeEnd !== -1) {
            const itemsToSelect = data.slice(rangeStart, rangeEnd + 1);
            const idsToSelect = itemsToSelect.map((item) => item.id);
            const combinedIds = new Set([...selectedItems, ...idsToSelect]);
            newSelectedItems = Array.from(combinedIds);
          } else {
            newSelectedItems = [...selectedItems, item.id];
          }
        } else {
          newSelectedItems = [...selectedItems, item.id];
        }

        return {
          selectedItems: newSelectedItems,
          lastChecked: item.id,
        };
      });
    }
    // TRƯỜNG HỢP 2: Click bình thường - Mở form Update trực tiếp
    else {
      this.onClickedUpdate(item);
    }
  };

  onClickedUpdate = (item) => {
    const {
      id,
      name,
      barcode,
      sku,
      unit,
      count,
      avarage_price,
      income,
      isSeen,
      is_alert_down_20,
      is_alert_down_10,
      price_new,
      total_value,
      total,
      category_name,
      warehouse_name,
      min_stock_threshold,
      batch_code,
      storage_location,
      stock_note,
      dynamic_form,
    } = item;

    const providerName =
      item?.company_provider_item?.company_provider?.name ||
      item?.company_provider_item?.name ||
      item?.provider_name ||
      "";
    const items_selected = providerName
      ? { label: providerName, value: providerName }
      : null;
    const expiry_date = item?.nearest_expiry_date || "";

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: true,
        updateCount: false,
      },
      form: {
        ...prev.form,
        id,
        name,
        barcode,
        sku,
        unit,
        count,
        avarage_price,
        income,
        isSeen,
        is_alert_down_20,
        is_alert_down_10,
        price_new,
        total_value,
        total,
        category_name,
        warehouse_name,
        brand_name: item?.brand_name || "",
        packing_specification: item?.packing_specification || "",
        min_stock_threshold,
        max_stock_threshold: item?.max_stock_threshold || 0,
        is_active: item?.is_active !== undefined ? Boolean(item.is_active) : true,
        batch_code: batch_code || "",
        storage_location: storage_location || "",
        stock_note: stock_note || "",
        dynamic_form,
        items_selected,
        expiry_date,
        isTemplate: Boolean(item.isTemplate),
      },
      selectedItems: [item.id],
    }));
  };

  onClickedUpdateCount = (item) => {
    this.replenishmentRequestId = null;
    const { id, name, sku, batch_code, storage_location } = item;
    const providerName =
      item?.company_provider_item?.company_provider?.name ||
      item?.company_provider_item?.name ||
      item?.provider_name ||
      "";
    const items_selected = providerName
      ? { label: providerName, value: providerName }
      : null;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        updateCount: true,
        update: false,
      },
      form: {
        ...prev.form,
        id,
        name,
        sku,
        new_count: 0,
        unit_price: 0,
        price_outcome: 0,
        items_selected,
        expiry_date: "",
        batch_code: batch_code || "",
        storage_location: storage_location || "",
        stock_note: "",
      },
    }));
  };

  onClickedDelete = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require",
    );
    if (window.confirm("Bạn chắc chắn muốn xoá nguyên liệu này?")) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerDelete(),
      );
    }
  };

  onClickedReset = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require",
    );
    if (
      window.confirm("Bạn chắc chắn muốn reset tồn kho nguyên liệu này về 0?")
    ) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerReset(),
      );
    }
  };

  onClickedCheckbox = (id, event) => {
    // Toggle selection: add if not present, remove if already selected
    this.setState((prev) => {
      const isSelected = prev.selectedItems.includes(id);
      const newSelectedItems = isSelected
        ? prev.selectedItems.filter((itemId) => itemId !== id)
        : [...prev.selectedItems, id];

      return {
        ...prev,
        selectedItems: newSelectedItems,
        lastChecked: id,
      };
    });
  };
  /** State func helper */

  toggleAccordion = (tab) => {
    const prevState = this.state.accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    this.setState({
      accordion: state,
    });
  };

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  filterData = (key, value) => {
    const { data_all } = this.state;
    let filteredData = data_all;
    let newFilter = { column: key, value };

    // Trường hợp reset filter
    if (!key && !value) {
      newFilter = null;
    } else {
      // Sử dụng switch-case để code rõ ràng hơn
      switch (key) {
        case "percentage_less_than":
          // Gộp 3 trường hợp 'less_than' thành 1
          // value ở đây nên là một con số
          filteredData = data_all.filter(
            (item) => (item.count / item.total) * 100 <= value,
          );
          break;

        case "price_new_status":
          if (value === "done") {
            // Lọc những item có giá trị price_new (lớn hơn 0, không phải null/undefined)
            filteredData = data_all.filter((item) => item.price_new);
          } else if (value === "not") {
            // Lọc những item không có giá trị price_new (bằng 0, null, hoặc undefined)
            filteredData = data_all.filter((item) => !item.price_new);
          }
          break;

        case "nDaysAgo":
          // 1. Đặt điểm kết thúc là cuối ngày hôm nay
          const endDate = new Date();
          endDate.setHours(23, 59, 59, 999);
          const endTimestamp = endDate.getTime();

          // 2. Đặt điểm bắt đầu
          const startDate = new Date(); // Lấy ngày hiện tại
          // Lùi lại (N-1) ngày để lấy ngày bắt đầu.
          // Ví dụ: 5 ngày gần đây (value=5) -> lùi lại 4 ngày.
          startDate.setDate(startDate.getDate() - (value - 1));
          startDate.setHours(0, 0, 0, 0); // Đặt giờ về đầu ngày
          const startTimestamp = startDate.getTime();

          // 3. Lọc trong khoảng [startDate, endDate]
          filteredData = data_all.filter((e) => {
            const itemTimestamp = new Date(e.updatedAt).getTime();
            return (
              itemTimestamp >= startTimestamp && itemTimestamp <= endTimestamp
            );
          });
          break;

        // Mặc định, lọc theo key và value một cách linh hoạt
        // Ví dụ: key='price_cost', value='done'
        default:
          filteredData = data_all.filter((item) => item[key] === value);
          break;
      }
    }

    // Chỉ gọi setState một lần duy nhất ở cuối hàm
    this.setState({
      data: filteredData,
      filter: newFilter,
    });
  };

  changeDisplayMode = (mode) => {
    this.setState((prev) => ({
      ...prev,
      displayMode: mode,
      show: {
        ...prev.show,
        view: false,
      },
    }));
    return false;
  };

  countLengthMakeProduct = (id) => {
    const { dataMakeProduct } = this.state;
    const findItem = dataMakeProduct.filter((item) => item.stock.id === id);
    if (findItem) {
      return findItem.length;
    }
    return 0;
  };

  handleChangeSelectAll = (isToggle) => {
    if (this.state.selectedItems.length >= this.state.data.length) {
      if (isToggle) {
        this.setState({
          selectedItems: [],
        });
      }
    } else {
      this.setState({
        selectedItems: this.state.data.map((x) => x.id),
      });
    }
    document.activeElement.blur();
    return false;
  };

  render() {
    const { match } = this.props;
    const {
      hide_button_add,
      page,
      selectedItems,
      data,
      data_all,
      is_loading_data,
      show,
      form,
      accordion,
      filter,
      displayMode,
      successfulImports,
      failedImports,
      data_providers,
      data_dynamic_form,
      stockImportReport,
      isImportingStockExcel,
    } = this.state;

    if (!isR(ROLE_ALIAS))
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            Bạn không có quyền sử dụng tính năng này!
          </CardBody>
        </Card>
      );

    if (is_loading_data) {
      return <div className="loading" />;
    }

    const brandOptions = Array.from(
      new Set(
        (data_all || [])
          .map((item) => item?.brand_name)
          .filter(Boolean)
          .map((item) => String(item).trim())
          .filter(Boolean),
      ),
    );

    if (this.state.uiMode === "new") {
      return (
        <div className="disable-text-selection">
          <AddStock
            title={<IntlMessages id="stock.add-new-modal-title" />}
            isOpen={show.add}
            toggle={() => {
              this.toggle("add");
            }}
            data_dynamic_form={data_dynamic_form}
            values={form}
            data_providers={data_providers}
            categoryOptions={
              this.state.dashboardData?.filter_options?.category_names || []
            }
            warehouseOptions={this.state.warehouseOptions}
            brandOptions={brandOptions}
            setting={show}
            onChange={this.onChangeForm}
            onReset={this.onClickedReset}
            onChangeDynamicForm={this.onChangeDynamicForm}
            onSubmit={this.onHandlerAdd}
          />
          <AddMoreStock
            title={<IntlMessages id="stock.count-update" />}
            isOpen={show.updateCount}
            toggle={() => {
              this.toggle("updateCount");
            }}
            values={form}
            data={data}
            data_providers={data_providers}
            setting={show}
            onChange={this.onChangeForm}
            onSubmit={this.onHandlerUpdateCount}
          >
            <ContentFormCountUpdate />
          </AddMoreStock>
          <UpdateStock
            title={<IntlMessages id="stock.count-edit" />}
            onSubmit={this.onHandlerUpdate}
            onSubmitCount={this.onHandlerUpdateCount}
            isOpen={show.update}
            toggle={() => {
              this.toggle("update");
            }}
            data_dynamic_form={data_dynamic_form}
            values={form}
            data_providers={data_providers}
            data_all={data_all}
            categoryOptions={
              this.state.dashboardData?.filter_options?.category_names || []
            }
            warehouseOptions={this.state.warehouseOptions}
            brandOptions={brandOptions}
            setting={show}
            onReset={this.onClickedReset}
            onChange={this.onChangeForm}
            onChangeDynamicForm={this.onChangeDynamicForm}
          />
          <StockImportHistoryModal
            isOpen={this.state.isOpenStockImportHistoryModal}
            toggle={this.toggleStockImportHistoryModal}
            stock={this.state.stockImportHistoryItem}
            canUpdate={isU(ROLE_ALIAS)}
            onSaved={this.handleStockImportHistorySaved}
          />
          <Modal
            isOpen={this.state.isOpenStockImportModal}
            toggle={this.toggleStockImportModal}
            className={classnames("table-modal cursor-pointer max-width-100")}
            size="lg"
          >
            <ModalHeader toggle={this.toggleStockImportModal}>
              Nhập kho bằng Excel
            </ModalHeader>
            <ModalBody>
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <div className="mb-2">
                  <strong>Nhập hàng loạt tồn kho</strong>
                  <small className="d-block text-muted">
                    Chọn file Excel để xem trước, chỉnh sửa và xác nhận nhập.
                  </small>
                </div>
                <div className="d-flex flex-wrap align-items-center mb-2">
                  <Button
                    color="outline-secondary"
                    size="sm"
                    className="mr-2 mb-2"
                    onClick={this.handleDownloadStockImportTemplate}
                  >
                    <i className="simple-icon-cloud-download mr-1" />
                    Tải file mẫu
                  </Button>
                  <label className="btn btn-outline-primary btn-sm mb-2">
                    <i className="simple-icon-cloud-upload mr-1" />
                    Chọn file Excel
                    <input
                      type="file"
                      accept=".xlsx, .xls"
                      onChange={this.handleStockExcelFileUpload}
                      style={{ display: "none" }}
                    />
                  </label>
                </div>
              </div>
              <ModalAddStocks
                handleImportStock={this.onHandlerImport}
                data_all={data_all}
                data_providers={data_providers || []}
                initialData={this.state.stockImportRows}
                importReport={stockImportReport}
                isImporting={isImportingStockExcel}
              />
            </ModalBody>
          </Modal>
          <StockDashboardLayout
            match={match}
            uiMode={this.state.uiMode}
            onToggleUiMode={this.toggleUIMode}
            filters={this.state.dashboardFilters}
            filterOptions={this.state.dashboardData?.filter_options}
            onFilterChange={this.onDashboardFilterChange}
            onApplyFilters={this.applyDashboardFilters}
            onResetFilters={this.resetDashboardFilters}
            onSearchKeyDown={this.onDashboardSearchKeyDown}
            onSearchChange={this.onDashboardSearchChange}
            onSearch={this.onDashboardSearch}
            data={data}
            allData={data_all}
            showTemplate={this.state.showTemplate}
            page={page}
            selectedItems={selectedItems}
            onToggleSelectAllCurrent={this.handleToggleSelectAllCurrent}
            onToggleItem={this.onClickedCheckbox}
            onChangePage={this.onChangePage}
            onChangePageSize={this.onChangePageSize}
            onExport={this.handleExportStock}
            onOpenAdd={() => {
              this.toggle("add");
              this.toggleAccordion();
            }}
            onOpenImport={this.toggleStockImportModal}
            onOpenUpdate={this.onClickedUpdate}
            onOpenUpdateCount={this.onClickedUpdateCount}
            onOpenImportHistory={this.openStockImportHistory}
            onDeleteItem={this.onClickedDelete}
            onDeleteSelected={() => {
              if (
                window.confirm("Bạn có chắc chắn muốn xóa những mục đã chọn?")
              ) {
                this.onHandlerDelete();
              }
            }}
            dashboardData={this.state.dashboardData}
            isLoadingDashboard={this.state.is_loading_dashboard}
            canCreate={isC(ROLE_ALIAS)}
            canUpdate={isU(ROLE_ALIAS)}
            canDelete={isD(ROLE_ALIAS)}
          />
          <Separator />
          <FooterPage>
            <FooterStock />
          </FooterPage>
        </div>
      );
    }

    /* LEGACY_STOCK_UI_START */
    return (
      <div
        // className={classnames(
        //     'disable-text-selection',
        //     displayMode === 'thumblist' ? 'app-row' : ''
        // )}
        className="app-row disable-text-selection"
      >
        <Row className="mb-2">
          <Col xs="12" className="d-flex justify-content-end">
            <Button
              color="outline-primary"
              size="sm"
              onClick={this.toggleUIMode}
            >
              Chuyển New UI
            </Button>
          </Col>
        </Row>
        <PageHeading
          heading="menu.stock"
          setting={page}
          match={match}
          data={data}
          totalItem={page.totalItem}
          hide_button_add={hide_button_add}
          toggleFunc={() => {
            this.toggle("add");
            this.toggleAccordion();
          }}
          changePageSizeFunc={this.onChangePageSize}
          onSearchKeyFunc={this.onSearchKey}
          displayMode={displayMode}
          changeDisplayMode={this.changeDisplayMode}
          failedImports={failedImports}
          successfulImports={successfulImports}
          selectedItemsLength={selectedItems.length}
          data_all={data_all}
          data_providers={data_providers}
          handleImportStock={this.onHandlerImport}
          onHandlerDelete={() => {
            if (
              window.confirm("Bạn có chắc chắn muốn xóa những mục đã chọn?")
            ) {
              this.onHandlerDelete();
            }
          }}
        />
        <AddStock
          title={<IntlMessages id="stock.add-new-modal-title" />}
          isOpen={show.add}
          toggle={() => {
            this.toggle("add");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          data_providers={data_providers}
          categoryOptions={
            this.state.dashboardData?.filter_options?.category_names || []
          }
          warehouseOptions={this.state.warehouseOptions}
          brandOptions={brandOptions}
          // sku={sku}
          setting={show}
          onChange={this.onChangeForm}
          onReset={this.onClickedReset}
          onChangeDynamicForm={this.onChangeDynamicForm}
          onSubmit={this.onHandlerAdd}
        />
        <AddMoreStock
          title={<IntlMessages id="stock.count-update" />}
          isOpen={show.updateCount}
          toggle={() => {
            this.toggle("updateCount");
          }}
          values={form}
          data={data}
          data_providers={data_providers}
          // sku={sku}
          setting={show}
          onChange={this.onChangeForm}
          onSubmit={this.onHandlerUpdateCount}
        >
          <ContentFormCountUpdate />
        </AddMoreStock>
        <UpdateStock
          title={<IntlMessages id="stock.count-edit" />}
          onSubmit={this.onHandlerUpdate}
          onSubmitCount={this.onHandlerUpdateCount}
          isOpen={show.update}
          toggle={() => {
            this.toggle("update");
          }}
          data_dynamic_form={data_dynamic_form}
          values={form}
          data_providers={data_providers}
          data_all={data_all}
          categoryOptions={
            this.state.dashboardData?.filter_options?.category_names || []
          }
          warehouseOptions={this.state.warehouseOptions}
          brandOptions={brandOptions}
          setting={show}
          onReset={this.onClickedReset}
          onChange={this.onChangeForm}
          onChangeDynamicForm={this.onChangeDynamicForm}
        />
        {data.length === 0 ? (
          <Card className="mt-4 mb-4 mh-53vh">
            <CardBody>Chưa có dữ liệu...</CardBody>
          </Card>
        ) : (
          <>
            {Array.isArray(data_all) && data_all.some((s) => Boolean(s.isTemplate)) ? (
              <Row className="mb-3">
                <Col xs="12">
                  <TemplateWarningCard
                    onDismissed={() => {
                      this.setState({ showTemplate: false });
                      this.dataListRender();
                      this.dataAllRender();
                      this.fetchUserTemplateVisibility();
                    }}
                  />
                </Col>
              </Row>
            ) : null}
            <Nav
              tabs
              className="d-flex justify-content-between separator-tabs ml-0 mb-5"
            >
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                    "nav-link": true,
                  })}
                  onClick={() => this.toggleTab("1")}
                  location={{}}
                  to="#"
                >
                  <IntlMessages id="general.info" />
                </NavLink>
              </NavItem>

              {/* <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: this.state.activeTab === '2',
                                        'nav-link': true,
                                    })}
                                    onClick={() => this.toggleTab('2')}
                                    location={{}}
                                    to='#'
                                >
                                    <span className='mr-2'>
                                        <i className='simple-icon-settings'></i>
                                    </span>
                                    <IntlMessages id='general.setting' />
                                </NavLink>
                            </NavItem> */}
            </Nav>
            <TabContent activeTab={this.state.activeTab} className="mh-53vh">
              <TabPane tabId="1">
                <Row className="content-page__row d-none d-md-flex">
                  <Col
                    xs="12"
                    sm="12"
                    md="12"
                    lg={show.view && displayMode === "thumblist" ? 6 : 12}
                    xl={show.view && displayMode === "thumblist" ? 6 : 12}
                  >
                    {data?.length ? (
                      displayMode === "thumblist" ? (
                        <>
                          {data.map((item, idx) => (
                            <ListItemLeftForm
                              onClickedItem={this.onClickedItem}
                              onUpdate={this.onClickedUpdate}
                              onUpdateCount={this.onClickedUpdateCount}
                              onDelete={this.onClickedDelete}
                              onChangeCheckbox={this.onClickedCheckbox}
                              isDisabledUpdate={!isU(ROLE_ALIAS)}
                              isDisabledDelete={!isD(ROLE_ALIAS)}
                              selectedItems={selectedItems}
                              key={idx}
                              idx={idx}
                              item={item}
                              countLengthMakeProduct={this.countLengthMakeProduct(
                                item.id,
                              )}
                            />
                          ))}
                          {/* {data?.length <
                                                    12 ? null : ( */}
                          <Pagination
                            currentPage={page.currentPage}
                            totalPage={page.totalPage}
                            onChangePage={(i) => this.onChangePage(i)}
                          />
                          {/* )} */}
                        </>
                      ) : (
                        <ContentMultiForm data={data_all} />
                      )
                    ) : (
                      <Card className="d-flex justify-content-center align-items-center">
                        <CardBody>Chưa có dữ liệu...</CardBody>
                      </Card>
                    )}
                  </Col>
                  {show.view ? (
                    <Col xs="12" sm="12" md="12" lg="6" xl="6">
                      <ContentDisplay
                        // data_dynamic_form={data_dynamic_form}
                        // data_tags={data_tags}
                        values={form}
                        data={data}
                        // sku={sku}
                      />
                    </Col>
                  ) : null}
                </Row>
                <Row className="content-page__row d-block d-md-none mb-4">
                  <Col>
                    {data?.length ? (
                      data.map((item, idx) => {
                        // console.log(item);
                        return (
                          <div className="d-flex mb-3 card" key={item.id}>
                            <ListItemFormMobile
                              onClickedItem={this.onClickedItem}
                              onUpdate={this.onClickedUpdate}
                              onDelete={this.onClickedDelete}
                              onChangeCheckbox={this.onClickedCheckbox}
                              isDisabledUpdate={!isU(ROLE_ALIAS)}
                              isDisabledDelete={!isD(ROLE_ALIAS)}
                              selectedItems={selectedItems}
                              key={idx}
                              idx={idx}
                              item={item}
                              data={data}
                              // sku={sku}
                              form={form}
                              accordion={accordion}
                              toggleAccordion={this.toggleAccordion}
                              countLengthMakeProduct={this.countLengthMakeProduct(
                                item.id,
                              )}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <Card className="d-flex justify-content-center align-items-center">
                        <CardBody>Chưa có dữ liệu...</CardBody>
                      </Card>
                    )}
                    {/* {data?.length < 12 ? null : ( */}
                    <Pagination
                      currentPage={page.currentPage}
                      totalPage={page.totalPage}
                      onChangePage={(i) => this.onChangePage(i)}
                    />
                    {/* )} */}
                  </Col>
                </Row>
              </TabPane>
              {/* <TabPane tabId='2'>Setting</TabPane> */}
            </TabContent>
          </>
        )}
        <StockApplicationMenu
          data_all={data_all}
          filterData={this.filterData}
          filter={filter}
        />

        <Separator />
        <FooterPage>
          <FooterStock />
        </FooterPage>
      </div>
    );
    /* LEGACY_STOCK_UI_END */
  }
}

const mapStateToProps = ({ searchInput }) => {
  const { keyword: searchKeyword } = searchInput;
  return { searchKeyword };
};

export default connect(mapStateToProps, {
  setSearchContext,
})(ContentComponent);
